module.exports = __webpack_public_path__ + "static/media/WarningTriangle.e66cc557.svg";